/* Classement des cartes.

   ⛔⛔ LA PERTINENCE PASSE DEVANT, TOUJOURS (Adrien, 05/09/2026 : « ça doit toujours
   montrer les résultats les plus pertinents en premier, classés par volume de vente puis
   nombre de vues »). Ce fichier faisait EXACTEMENT l'inverse depuis le 03/08 : ventes,
   puis vues, et la pertinence de Shopify seulement en troisième clé, donc jamais lue,
   puisque deux affiches ont rarement le même compte de ventes ET de vues.

   Les quatre défauts signalés le 05/09 sont cette seule inversion :
     « nice »     -> les affiches de Corse avant celles de Nice ;
     « bruxelle » -> une affiche de joueurs de foot en tête ;
     « horse »    -> des oliviers et des amphores ;
     « rennes », « ville rouen » -> aucun résultat pertinent visible.
   Mesure du 05/09 sur /search-log/popularite : « arche, amphore et horizon bleu » 30
   ventes, « olivier au bol » 26, « porte verte Mallorca » 13. Ce sont les meilleures
   ventes de la boutique, et le tri les posait en tête de N'IMPORTE QUELLE requête, y
   compris celles où elles n'ont aucun mot en commun avec ce qui est tapé. Charger cinq
   pages avant de trier aggravait le tout : on allait chercher plus loin de quoi couvrir
   les résultats que Shopify avait bien placés.

   L'ordre est donc : pertinence, puis ventes, puis vues, puis l'ordre rendu par la page.
   Les ventes et les vues départagent ce qui est ÉGALEMENT pertinent ; elles ne classent
   plus ce qui ne l'est pas.

   ⚠️ Shopify ne sait pas trier une recherche : `sort_by=best-selling` sur /search rend
   exactement le même ordre que sans lui, vérifié sur la boutique le 03/08/2026. Le tri se
   fait donc sur les cartes rendues.

   La source de popularité existe déjà et sert le rail de suggestions et le composeur de
   mur : `/search-log/popularite` rend { handle: [ventes, vues] } pour tout le catalogue.
   Le fichier d'assets sert de secours ; en échec, l'ordre de la page reste, jamais
   d'écran vide.

   La pertinence, elle, se calcule sur `data-hay` (titre | tags | type | corps), posé par
   la carte, et sur `data-tri-termes`, écrit sur la grille par la page de recherche : les
   trois listes de mots sans poids vivent là-bas, et deux copies finissent par diverger.

   ⛔ L'OBSERVATEUR NE DOIT PAS SE VOIR TRAVAILLER. Un simple drapeau ne suffit
   pas : les enregistrements de MutationObserver sont livrés APRÈS la tâche en
   cours, donc le drapeau est déjà retombé quand le rappel s'exécute, le tri se
   relance sur ses propres déplacements et la page scintille en boucle (Adrien,
   03/08/2026, recherche cassée en production). Deux verrous, pas un : on
   débranche l'observateur pendant le tri ET on ne retrie que si le NOMBRE de
   cartes a changé, ce qu'un simple réordonnancement ne fait jamais. */
(function () {
  var grille = document.querySelector("[data-products][data-tri-popularite]");
  if (!grille || !window.fetch) return;
  /* Sur la recherche le tri s'applique toujours ; sur une collection, seulement
     quand la page vient d'une recherche par couleur (marqueur tri=populaire).
     Sans cette garde, on ecraserait le tri que le client a choisi lui-meme. */
  var quand = grille.getAttribute("data-tri-popularite");
  if (quand === "si-marque" && String(location.search).indexOf("tri=populaire") === -1) return;
  var URL_POP = grille.getAttribute("data-pop-url");
  var REPLI = grille.getAttribute("data-pop-repli");
  var pop = null, dernierNombre = -1, observateur = null, attente = null;

  /* Les mots utiles de la requete, ecrits par la page de recherche. Vide sur une
     collection : il n'y a alors rien a rendre pertinent, et le tri par ventes reprend
     seul, ce qui est bien ce qu'on lui demande la. */
  var TERMES = [];
  try { TERMES = JSON.parse(grille.getAttribute("data-tri-termes") || "[]") || []; } catch (e) { TERMES = []; }

  function aplatir(t) {
    return String(t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  /* ⛔ LE TERME DOIT COMMENCER UN MOT, PAS SE CACHER DEDANS. Meme borne que la page de
     recherche : « lille » se trouve dans « brille », « famille », « vanille ». On ne borne
     que le debut, « sicil » doit continuer de trouver « sicilienne ». */
  /* Rend la longueur du PLUS COURT mot que le terme commence, 0 s'il n'en commence aucun.
     ⛔ LA LONGUEUR DECIDE, PAS SEULEMENT LA PRESENCE. Mesure du 05/09 sur le marche polonais :
     « koń » s'aplatit en « kon », qui commence « Konie » (les chevaux, la bonne reponse) mais
     aussi « Koncentryczne », « konkretna », « konsoli », « Kontemplacyjny » et « końcu ». Un
     booleen les met tous a egalite, et c'est la porte de Provence qui ouvrait la page.
     ⚠️ ON NE PEUT PAS EXIGER LE MOT ENTIER : « Konie » n'est pas « koń », et « sicil » doit
     continuer de trouver « sicilienne ». C'est la PART du mot que le terme couvre qui separe
     « Konie » (3 signes sur 5) de « Kontemplacyjny » (3 sur 14). */
  function debutDeMot(hay, terme) {
    var i = hay.indexOf(terme);
    var court = 0;
    while (i !== -1) {
      var avant = i === 0 ? "" : hay.charAt(i - 1);
      /* `[a-z0-9]` ne bornait rien hors du latin nu : en grec, chaque signe passait pour un
         debut de mot. Meme correction que dans la page de recherche. */
      if (!/[\p{L}\p{N}]/u.test(avant)) {
        var j = i + terme.length;
        while (j < hay.length && /[\p{L}\p{N}]/u.test(hay.charAt(j))) j += 1;
        var n = j - i;
        if (!court || n < court) court = n;
      }
      i = hay.indexOf(terme, i + 1);
    }
    return court;
  }
  /* Le champ ou le mot se trouve pese : un sujet nomme dans le titre vaut mieux que le
     meme mot croise dans un corps de fiche. Mais le NOMBRE de termes trouves domine :
     sur « ville rouen », une affiche qui porte les deux passe devant toutes celles qui
     n'en portent qu'un, quel que soit le champ. */
  var POIDS = [4, 3, 1, 2];   // titre | tags | type | corps
  function pertinence(carte) {
    if (!TERMES.length) return 0;
    var connu = carte.getAttribute("data-pert");
    if (connu !== null) return +connu;
    var brut = carte.getAttribute("data-hay");
    /* Repli : sans data-hay, le titre affiche est toujours la. Une carte sans foin ne
       doit jamais compter zero par accident, ce serait la reléguer pour un defaut de
       gabarit et non pour un defaut de pertinence. */
    var champs = brut === null ? [carte.textContent] : String(brut).split("|");
    for (var f = 0; f < champs.length; f++) champs[f] = aplatir(champs[f]);
    var trouves = 0, poids = 0;
    for (var t = 0; t < TERMES.length; t++) {
      var meilleur = 0;
      for (var c = 0; c < champs.length; c++) {
        var p = brut === null ? POIDS[0] : (POIDS[c] || 1);
        var n = debutDeMot(champs[c], TERMES[t]);
        /* Le mot entier vaut le poids plein du champ, un long mot dont le terme n'est que le
           debut en vaut la moitie : le terme est trouve, il l'est juste moins franchement. */
        var note1 = n ? p * (0.5 + 0.5 * (TERMES[t].length / n)) : 0;
        if (note1 > meilleur) meilleur = note1;
      }
      if (meilleur) { trouves += 1; poids += meilleur; }
    }
    /* Le NOMBRE de mots trouves domine toujours : sur « ville rouen », porter les deux bat
       porter un seul, quel que soit le champ ou la franchise du match. */
    var note = trouves * 1000 + Math.round(poids * 100);
    carte.setAttribute("data-pert", note);
    return note;
  }

  function trier() {
    if (!pop) return;
    var cartes = Array.prototype.slice.call(grille.children);
    if (!cartes.length) return;
    if (observateur) observateur.disconnect();
    /* ⛔ DEDOUBLONNAGE. Le thème enchaîne lui-même « voir plus » tant que le bas
       de page est visible : en pilotant le bouton, on peut demander la même page
       deux fois et la carte apparaissait en double (Adrien, 03/08/2026,
       « bateau »). On ne garde que la première occurrence d'un handle. */
    var vus = {};
    cartes = cartes.filter(function (c) {
      var h = c.getAttribute("data-handle");
      if (!h) return true;
      if (vus[h]) { if (c.parentNode) c.parentNode.removeChild(c); return false; }
      vus[h] = 1;
      return true;
    });
    cartes.forEach(function (c, i) {
      if (c.getAttribute("data-rang") === null) c.setAttribute("data-rang", i);
    });
    /* ⛔ UN CADRE OU UN CROCHET N'EST PAS UN BEST SELLER D'AFFICHE. Les
       accessoires se vendent avec chaque commande, donc leurs ventes ecrasent
       celles des affiches : le crochet mural, 15 ventes, prenait la tete d'une
       recherche « bateau » (Adrien, 03/08/2026). Ils gardent leur place rendue
       par Shopify, ils ne sont simplement pas promus. */
    function score(c) {
      var t = (c.getAttribute("data-type") || "").toLowerCase();
      if (t === "cadre" || t === "accessoire") return [0, 0];
      return pop[c.getAttribute("data-handle")] || [0, 0];
    }
    cartes.sort(function (a, b) {
      var pA = pertinence(a);
      var pB = pertinence(b);
      if (pB !== pA) return pB - pA;                                       // pertinence
      var A = score(a);
      var B = score(b);
      if ((B[0] || 0) !== (A[0] || 0)) return (B[0] || 0) - (A[0] || 0);   // ventes
      if ((B[1] || 0) !== (A[1] || 0)) return (B[1] || 0) - (A[1] || 0);   // vues
      return (+a.getAttribute("data-rang")) - (+b.getAttribute("data-rang"));
    });
    var lot = document.createDocumentFragment();
    cartes.forEach(function (c) { lot.appendChild(c); });
    grille.appendChild(lot);
    dernierNombre = grille.children.length;
    brancher();
  }

  function brancher() {
    if (!window.MutationObserver) return;
    if (!observateur) {
      observateur = new MutationObserver(function () {
        /* Un réordonnancement ne change pas le compte : seul un ajout retrie. */
        if (grille.children.length === dernierNombre) return;
        if (attente) clearTimeout(attente);
        attente = setTimeout(trier, 60);
      });
    }
    observateur.takeRecords();          // on jette ce que le tri vient de produire
    observateur.observe(grille, { childList: true });
  }

  function lire(u) {
    if (!u) return Promise.reject();
    return fetch(u).then(function (r) { return r.ok ? r.json() : Promise.reject(); });
  }
  /* ⛔ TRIER CE QUI EST CHARGE NE SUFFIT PAS. Shopify rend 24 cartes par page et
     classe par pertinence : une affiche qui a vendu mais que la pertinence range
     en page 3 ne remontait jamais en tete (Adrien, 03/08/2026, « marseille » :
     114 resultats, le best seller absent des 24 premieres cartes). On charge donc
     les pages suivantes AVANT de trier, en pilotant le bouton « voir plus »
     existant plutot qu'en refaisant sa mecanique.
     Plafond a 5 pages : au-dela le cout depasse le gain, et le reste garde
     l'ordre de Shopify. La grille est masquee le temps du chargement, avec une
     echeance : un incident reseau ne doit jamais laisser une page vide. */
  var PAGES_MAX = 5;
  function chargerPuisTrier() {
    var pages = 1, rendu = false;
    var echeance = setTimeout(montrer, 2500);
    /* ⛔ L'ECHEANCE REVELE, ELLE N'ARRETE PAS LE CHARGEMENT. Melangees, la page
       s'affichait au bout de 2,5 s ET cessait de charger : 72 cartes sur 114, et
       l'affiche vendue restait hors du lot (Adrien, 03/08/2026). Le chargement va
       jusqu'au plafond, l'observateur retrie a chaque arrivee. */
    function montrer() {
      if (rendu) return;
      rendu = true;
      clearTimeout(echeance);
      grille.style.visibility = "";
      trier();
    }
    if (grille.children.length) grille.style.visibility = "hidden";
    (function suivant() {
      var lien = document.querySelector("[data-more-link]");
      if (!lien || lien.hidden || pages >= PAGES_MAX) { montrer(); return; }
      var avant = grille.children.length;
      pages += 1;
      lien.click();
      var essais = 0;
      var minuteur = setInterval(function () {
        essais += 1;
        if (grille.children.length !== avant || essais > 25) {
          clearInterval(minuteur);
          setTimeout(suivant, 20);
        }
      }, 100);
    })();
  }

  lire(URL_POP).catch(function () { return lire(REPLI); })
    .then(function (d) {
      pop = (d && d.pop) || null;
      if (!pop) return;
      if (quand === "toujours") chargerPuisTrier(); else trier();
    })
    .catch(function () { pop = null; });
})();
